import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';
import get from 'lodash/get';
import MemberLink from '../members/MemberLink.react';
import MemberName from '../members/MemberName.react';
import MemberImage from '../members/MemberImage.react';
import ImageSvg from '../images/ImageSvg.react';
import Checkbox from '../misc/Checkbox.react';
import Time from '../misc/Time.react';
import DropdownMenu from '../misc/DropdownMenu.react';
import DropdownMenuItem from '../misc/DropdownMenuItem.react';
import cx from '../../utils/cx.js';
import popup from '../../../app/popup.js';
import VerificationBadge from '../../../../react/components/verification/VerificationBadge';

const ReactPropTypes = PropTypes;

class MessageItem extends React.Component {
  static propTypes = {
    id: ReactPropTypes.string,
    messageId: ReactPropTypes.string,
    type: ReactPropTypes.string, // 'message' , 'conversation'
    memberId: ReactPropTypes.string,
    verified: ReactPropTypes.bool,
    large: ReactPropTypes.bool,
    indent: ReactPropTypes.bool,
    disableHover: ReactPropTypes.bool,
    new: ReactPropTypes.bool,
    unread: ReactPropTypes.bool,
    deleted: ReactPropTypes.bool,
    showReadIcon: ReactPropTypes.bool,
    truncateName: ReactPropTypes.number,
    date: ReactPropTypes.number,
    text: ReactPropTypes.instanceOf(Array),
    disableUserLink: ReactPropTypes.bool,
    imageType: ReactPropTypes.string,
    pointer: ReactPropTypes.bool,
    checked: ReactPropTypes.bool,
    onClick: ReactPropTypes.func,
    onClickDelete: ReactPropTypes.func,
    onClickReport: ReactPropTypes.func,
    onChecked: ReactPropTypes.func,
    showCheckboxes: ReactPropTypes.bool,
    showReport: ReactPropTypes.bool,
    reported: ReactPropTypes.bool,
    hidden: ReactPropTypes.bool,
    showHiddenText: ReactPropTypes.string,
    mobile: ReactPropTypes.bool,
  };

  static defaultProps = {
    id: null,
    messageId: '',
    type: 'message',
    memberId: null,
    verified: false,
    large: false,
    indent: false,
    disableHover: false,
    new: false,
    unread: false,
    deleted: false,
    showReadIcon: false,
    active: false,
    truncateName: 12,
    date: null,
    text: '',
    disableUserLink: false,
    imageType: 's',
    pointer: false,
    checked: false,
    onClick: null,
    onClickDelete: null,
    onClickReport: null,
    onChecked: null,
    showCheckboxes: false,
    showReport: false,
    reported: false,
    hidden: false,
    showHiddenText: '',
    mobile: false,
  };

  render() {
    const self = this;

    // checkbox
    const showCheckbox = () => {
      if (!self.props.showCheckboxes) {
        return;
      }

      return (
        <div className="messageItem-checkbox">
          <Checkbox id={self.props.type + self.props.messageId} checked={self.props.checked} onChecked={self.props.onChecked} />
        </div>
      );
    };

    // read
    const showRead = () => {
      if (self.props.showReadIconUnpaid) {
        return (
          <a
            onClick={popup.featureMessage.bind(self, 'see_read_messages')}
            className="messageItem-read messageItem-read--unpaid"
          >
            <ImageSvg svg="icon-checkmarkquestion" full />
          </a>
        );
      }

      if (!self.props.showReadIcon) {
        return;
      }

      if (self.props.unread) {
        return (
          <div className="messageItem-read messageItem-read--unread">
            <ImageSvg svg="icon-checkmark" full />
          </div>
        )

      }

      return (
        <div className="messageItem-read">
          <ImageSvg svg="icon-checkmarkdouble" full />
        </div>
      )
    }

    const messageItemMenu = () => {
      const showDelete = typeof self.props.onClickDelete === 'function';
      const showReport = self.props.showReport && !this.props.reported && typeof self.props.onClickReport === 'function';
      if (!showDelete && !showReport) {
        return (null);
      }

      const deleteText = get(translations, 'txt: Dzēst', 'txt: Dzēst');
      const reportText = get(translations, 'txt: Ziņot par pārkāpumu', 'txt: Ziņot par pārkāpumu');

      if (!self.props.mobile) {
        return (
          <div>
            {showDelete && (
              <div
                className="messageItem-delete tooltip tooltip--left tooltip--big"
                onClick={self.props.onClickDelete}
                data-tooltip={deleteText}
              >
                <ImageSvg svg="icon-trash" full />
              </div>
            )}
            {showReport && (
              <div
                className={cx([
                  'messageItem-report tooltip tooltip--left tooltip--big',
                  ['db_', self.props.showReport],
                ])}
                onClick={self.props.onClickReport}
                data-tooltip={reportText}
              >
                <ImageSvg svg="icon-warning-2" full />
              </div>
            )}
          </div>
        )
      }

      const dropdownMenuItem = [];
      if (showDelete) {
        dropdownMenuItem.push(
          <DropdownMenuItem
            key="dropdown_delete"
            title={deleteText}
            onClickItem={self.props.onClickDelete}
          />,
        );
      }

      if (showReport) {
        dropdownMenuItem.push(
          <DropdownMenuItem
            key="dropdown_report"
            title={reportText}
            onClickItem={self.props.onClickReport}
          />,
        );
      }

      return (
        <div className="messageItem-actionsMore">
          <DropdownMenu>
            {dropdownMenuItem}
          </DropdownMenu>
        </div>
      )
    }

    return (
      <div
        className={cx([
          'messageItem',
          ['messageItem--large', this.props.large],
          ['messageItem--indent', this.props.indent],
          ['messageItem--hidden', this.props.hidden],
          ['disable-active', this.props.disableHover || this.props.deleted],
          ['is-new', (this.props.new && !this.props.active)],
          ['is-active', this.props.active && !this.props.deleted],
          ['is-unread', this.props.unread],
          ['is-deleted', this.props.deleted],
          ['is-reported', this.props.reported],
          ['is-checked', this.props.checked],
          ['has-pointer', this.props.pointer],
        ])}
        id={this.props.id}
      >
        <div
          className="messageItem-inner"
          onClick={this.props.onClick}
        >
          <div
            className="messageItem-showHidden"
            onClick={self.props.onClickShowHidden}
          >
            {this.props.showHiddenText}
          </div>
          <div className="messageItem-image">
            <MemberLink
              key={this.props.memberId}
              memberId={this.props.memberId}
              disable={this.props.disableUserLink}
            >
              <MemberImage
                memberId={this.props.memberId}
                type={this.props.imageType}
                key={this.props.memberId}
              />
            </MemberLink>
          </div>
          <div className="messageItem-main">
            <div className="group">
              <div className="messageItem-main-name">
                <MemberLink
                  key={this.props.memberId}
                  memberId={this.props.memberId}
                  disable={this.props.disableUserLink}
                >
                  <MemberName
                    key={this.props.memberId}
                    memberId={this.props.memberId}
                    truncate={this.props.truncateName}
                  />
                </MemberLink>
                {this.props.verified && (
                  <VerificationBadge tooltipRightSide />
                )}
              </div>
              <div className="messageItem-main-date">
                <Time
                  showDay={this.props.showDay}
                  key={this.props.date}
                  date={this.props.date}
                  timeago
                />
              </div>
            </div>
            <div className="messageItem-main-text">
              {this.props.text}
            </div>
          </div>
        </div>
        {messageItemMenu()}
        {showCheckbox()}
        {showRead()}
      </div>
    );
  }
}

module.exports = MessageItem;
